import { useEffect, useRef } from "react";

export const isBlockedPaymentPolicy = (event) => event.disposition === "enforce" &&
  ["form-action", "frame-src", "child-src"].includes(event.effectiveDirective);

export default function usePaymentSecurityPolicy(enabled, onBlocked) {
  const callbackRef = useRef(onBlocked);
  callbackRef.current = onBlocked;
  useEffect(() => {
    if (!enabled) return undefined;
    const handleViolation = (event) => {
      if (isBlockedPaymentPolicy(event)) callbackRef.current(event.effectiveDirective);
    };
    document.addEventListener("securitypolicyviolation", handleViolation);
    return () => document.removeEventListener("securitypolicyviolation", handleViolation);
  }, [enabled]);
}
